import { Box } from '@vp/swan';
import { useStyles } from '@vp/ubik-context';
import styles, { stylesheet } from './SlidePickers.module.scss';

interface SlidePickersProps {
    slideCount: number;
    currentSlide: number;
    onClick: (index: number) => void;
}

const SlidePickers = ({ slideCount, currentSlide, onClick }: SlidePickersProps) => {
    useStyles(stylesheet);

    return (
        <Box className={styles.slidePickers}>
            {Array.from({ length: slideCount }, (_, index) => (
                <button
                    key={`slide-${index}`}
                    className={`${styles.slidePicker} ${index === currentSlide ? styles.active : ''}`}
                    onClick={() => onClick(index)}
                    // TODO: Localise aria-label
                    aria-label={`Go to slide ${index + 1}`}
                />
            ))}
        </Box>
    );
};

export default SlidePickers;
